import React, {useRef} from 'react';
import { createPortal } from 'react-dom';
import '../../styles/form.css';
import Card from './Card';

export default function Modal({ isOpen, onClose, title, children, className = '' }) {
    if (!isOpen) return null;
    if (typeof document === 'undefined') return null;

    const mouseDownOnOverlay = useRef(false);

    const handleClose = () => {
        onClose();
    }

    return createPortal(
        <div className="modal-overlay" onMouseDown={(e) => {
            // Did the press start on overlay?
            mouseDownOnOverlay.current = (e.target === e.currentTarget);
        }}
        onMouseUp={(e) => {
            // Close ONLY if both down + up happened on overlay
            if (
                mouseDownOnOverlay.current &&
                e.target === e.currentTarget
            ) {
                handleClose();
            }
            mouseDownOnOverlay.current = false;
        }}
          >
            <Card
                className={`modal-content ${className}`}
                onClick={(e) => e.stopPropagation()}
            >
                {title && (
                    <div className="modal-header">
                        <h3 className="modal-title">{title}</h3>
                        <button className="modal-close-btn" onClick={onClose}>&times;</button>
                    </div>
                )}
                <div className="modal-body">
                    {children}
                </div>
            </Card>
        </div>,
        document.body,
    );
}
